/* eslint-disable global-require */
import axios from 'axios';
import FileSaver from 'file-saver';
import { CAC_TYPE } from '../res/Constants';
import { removeNullProperties } from '../utils/Utils';
import { getCurrentUserDataAsync } from './AccountService';
import { loadCacType } from './CacTypeService';
import { EXCEL_EXTENSION, MIME_TYPE_EXCEL } from './ServiceConstants';
import { toastError } from '../ui/ToastHelper';

const GET_TECHFORM_LIST = '/techforms';
const GET_TECHFORM_LIST_SIZE = `${GET_TECHFORM_LIST}/size`;
const DOWNLOAD_EXCEL = `${GET_TECHFORM_LIST}/export`;

export async function getTechformListSize(filters) {
    const currentCacType = loadCacType();
    const normalizedFilters = normalizeStandFilter(filters);
    if (normalizedFilters == null) return null;
    return (
        await axios({
            method: 'get',
            url: GET_TECHFORM_LIST_SIZE,
            params: await createParamsForTechformList(normalizedFilters, currentCacType)
        })
    ).data;
}

export async function getTechformList(cacType, filters) {
    const filtersByType = cacType === CAC_TYPE.CROP ? filters.crop : filters.nursery;
    if (cacType == null || filtersByType == null) return null;

    const normalizedFilters = normalizeStandFilter(filtersByType);
    if (normalizedFilters == null) return null;

    const params = await createParamsForTechformList(normalizedFilters, cacType);
    const { data } = await axios({
        method: 'get',
        url: GET_TECHFORM_LIST,
        params
    });
    return data;
}

async function createParamsForTechformList(filters, currentCacType) {
    const params = removeNullProperties({ ...filters, type: currentCacType });
    const userData = await getCurrentUserDataAsync();
    if (params.clientCode == null && userData.client != null) {
        params.clientCode = userData.client.code;
    }
    return params;
}

function normalizeStandFilter(filters) {
    if (filters == null) return null;
    const { stand } = filters;
    if (stand == null || stand === '') {
        return filters;
    }

    const numericStand = Number(stand);
    if (!Number.isFinite(numericStand) || numericStand <= 0 || numericStand > 100) {
        toastError('Stand must be a positive number up to 100.');
        return null;
    }

    return { ...filters, stand: numericStand };
}

export function downloadExcel(filters, lines, onSuccessCallback, onErrorCallback) {
    console.log('FILTERS', filters);
    if (filters === null) {
        console.log('filters are null');
        onErrorCallback('No filters selected.');
        return;
    }
    axios({
        method: 'get',
        url: DOWNLOAD_EXCEL,
        responseType: 'blob',
        params: {
            format: EXCEL_EXTENSION,
            lines,
            ...filters
        }
    })
        .then((response) => {
            const blob = new Blob([response.data], {
                type: MIME_TYPE_EXCEL
            });
            const fileName = `crop-reportworksheet-${lines}.${EXCEL_EXTENSION}`;
            FileSaver.saveAs(blob, fileName);
            onSuccessCallback && onSuccessCallback();
        })
        .catch((error) => onErrorCallback && onErrorCallback(error));
}
